<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-11 09:38:31
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-06 15:57:54
-->
<template>
  <div class="innovative innovative-aneuguide" :class="{textj: language != 'en'}">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.aneuguide.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <el-row :gutter="60" class="innovative-wrap-item flex p-b-120" :class="{align_items_center: language != 'en'}">
          <el-col :span="13" class="">
            <img class="" :src="$t('product.aneuguide.list[0].img')" alt="" srcset="">
          </el-col>
          <el-col :span="11" class="">
            <div class="innovative-item-title" v-html="$t('product.aneuguide.list[0].title')"></div>
            <div class="p-t-26 textj">
              <p :class="{'p-b-30': index < $t('product.aneuguide.list[0].des').length - 1 && language != 'en'}" v-for="item, index in $t('product.aneuguide.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel aneuguide-characteristics">
        <img v-if="language != 'en'" class="wh100" :src="$t('product.aneuguide.list[1].imgBj')" alt="" srcset="">
        <div class="t-0 wh100 innovative-container p-t-50 p-b-50" :class="language != 'en' ? 'posabs' : ''">
          <div v-if="language == 'en'" class="innovative-characteristics flex align_items_center justify_content_between">
            <div>
              <div class="innovative-item-title" v-html="$t('product.aneuguide.list[1].title')"></div>
              <div class="flex justify_content_between">
                <div class="p-t-24 flex_3">
                  <div class="innovative-wrap-item-title p-b-15" v-html="$t('product.aneuguide.list[1].des')[0].title"></div>
                  <p class="innovative-characteristics-item" v-for="$item, $index in $t('product.aneuguide.list[1].des')[0].list" :key="$index" v-html="$item"></p>
                </div>
                <div class="flex_2">
                  <img class="" :src="$t('product.aneuguide.list[1].img')" alt="" srcset="">
                </div>
              </div>
              <div class="trans-list p-r-20">
                <div class="p-t-44">
                  <div class="innovative-wrap-item-title p-b-15" v-html="$t('product.aneuguide.list[1].des')[1].title"></div>
                  <p class="innovative-characteristics-item" v-for="$item, $index in $t('product.aneuguide.list[1].des')[1].list" :key="$index" v-html="$item"></p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="innovative-characteristics flex align_items_center justify_content_between">
            <div class="trans-list p-r-20">
              <div class="innovative-item-title" v-html="$t('product.aneuguide.list[1].title')"></div>
              <div class="p-t-24">
                <div :class="index == 1 ? 'p-t-30' : ''" v-for="item, index in $t('product.aneuguide.list[1].des')" :key="index">
                  <div class="innovative-wrap-item-title p-b-15" v-html="item.title"></div>
                  <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                </div>
              </div>
            </div>
            <div class="p-l-40">
              <img class="" :src="$t('product.aneuguide.list[1].img')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
      <div class="aneuguide-other">
        <div class="innovative-container">
          <div class="innovative-item-title" :class="language == 'en' ? 'ilblk widauto p-r-60' : ''" v-html="$t('product.aneuguide.list[2].title')"></div>
          <el-row :gutter="clientWidth > 1600 ? 100 : 60" class="aneuguide-others-box clearfix flex">
            <el-col :span="8" class="flex" v-for="item, index in $t('product.aneuguide.list[2].des')" :key="index">
              <div class="aneuguide-other-item">
                <img class="wid100" :src="item.img" alt="" srcset="">
                <div class="aneuguide-other-item-des" :class="{en: language == 'en'}">
                  <p v-html="item.des"></p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="innovative-container">
        <div class="innovative-wrap-item p-t-50 article">
          <div class="innovative-item-title" v-html="$t('product.aneuguide.article.title')"></div>
          <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.aneuguide.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language', 'scrollTop', 'clientHeight', 'clientWidth'])
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-aneuguide {
  padding-bottom: 50PX;
  .innovative-characteristics {
    padding: 0 75PX;
  }
  .aneuguide-other {
    background: #F8FBFF;
    padding: 50PX 0;
    .aneuguide-others-box {
      .aneuguide-other-item {
        box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
        .aneuguide-other-item-des {
          padding: 28PX 40PX;
          font-size: 18PX;
          &.en {
            padding: 15PX 25PX;
            font-size: 16PX;
          }
        }
      }
    }
  }
}

.pc.en .innovative-aneuguide {
  .aneuguide-characteristics {
    background-image: url('~@/assets/images/innovate/AneuGuide/3.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .innovative-characteristics {
      padding: 32PX 75PX;
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1620PX) {
  .pc.zh .innovative-aneuguide {
    .aneuguide-characteristics {
      height: 670PX;
    }
  }
}
</style>
